<template>
  <div style="white-space:nowrap;overflow:auto">
    <div class="d-flex">
      <div class="m-3">
        <span class="card-span">
          <img :src="$store.getters.getBaseUrl+'/api/file/'+selectedPaket.icon">
          {{ selectedPaket.nama_paket }}
          <b-button
            v-b-tooltip
            variant="danger"
            size="sm"
            class="ml-2"
            title="Ubah Layanan"
            @click="setStep(1)"
          ><i class="fa fa-times mr-2" />Ubah</b-button>
        </span>
      </div>
      <div
        class="my-3"
        style="padding: 15px 0"
        v-if="dataPermohonan.tahap > 2"
      >
        <i class="fa fa-angle-right" />
      </div>
      <div
        class="m-3"
        v-if="dataPermohonan.tahap > 2"
      >
        <span class="card-span">
          <img :src="$store.getters.getBaseUrl+'/api/file/'+selectedPaket.icon">
          {{ layananSelected.nama_layanan }}
          <b-button
            v-b-tooltip
            variant="primary"
            size="sm"
            class="ml-2"
            title="Lihat Syarat Layanan"
            @click="lihatSyarat"
          ><i class="fa fa-list mr-2" />Syarat</b-button>
          <b-button
            v-b-tooltip
            variant="danger"
            size="sm"
            class="ml-2"
            title="Ubah Layanan"
            @click="setStep(2)"
          ><i class="fa fa-times mr-2" />Ubah</b-button>
        </span>
      </div>
      <div
        class="my-3"
        style="padding: 15px 0"
        v-if="dataPermohonan.is_form_online > 0"
      >
        <i class="fa fa-angle-right" />
      </div>
      <div
        class="m-3"
        v-if="dataPermohonan.is_form_online > 0"
      >
        <span
          class="card-span"
          v-if="dataPermohonan.is_form_online === 1"
        >
          <img :src="require('./../../assets/img/icon/computer.png')">
          Form Online
          <b-button
            v-b-tooltip
            variant="danger"
            size="sm"
            class="ml-2"
            title="Ubah Jenis Form"
            @click="ubahJenisForm"
          ><i class="fa fa-times mr-2" />Ubah</b-button>
        </span>
        <span
          class="card-span"
          v-if="dataPermohonan.is_form_online === 2"
        >
          <img :src="require('./../../assets/img/icon/pencil.jpg')">
          Form Manual
          <b-button
            variant="danger"
            size="sm"
            class="ml-2"
            @click="ubahJenisForm"
          ><i class="fa fa-times mr-2" />Ubah</b-button>
        </span>
      </div>
    </div>
    <b-modal
      id="modal-lihat-layanan"
      size="lg"
      v-if="dataPermohonan.tahap > 2"
    >
      <template #modal-title>
        <div
          v-if="layananSelected"
          class="d-flex"
        >
          <div class="layanan-icon mr-3 text-center">
            <img :src="$store.getters.getBaseUrl+'/uploads/icon-layanan/'+layananSelected.icon">
          </div>
          <div v-if="layananSelected.paket_layanan">
            <h5 class="mb-1">
              {{ layananSelected.nama_layanan }}
            </h5>
            <small class="text-muted">{{ selectedPaket.nama_paket }}</small>
          </div>
        </div>
      </template>
      <div v-if="layananSelected">
        <h6 class="mt-4">
          <i
            class="fa fa-user text-primary"
            style="width:1.5rem"
          />Data Layanan
        </h6>
        <div class="pl-4">
          <p v-if="layananSelected.paket_layanan">
            <b>Petunjuk</b><br>
            Petunjuk lengkap tentang pengajuan {{ layananSelected.nama_layanan }} dapat didownload dengan menekan tombol berikut:
            <br>
            <a
              v-if="layananSelected.paket_layanan"
              class="btn btn-sm btn-primary text-white"
              :href="$store.getters.getBaseUrl+'/api/file/'+layananSelected.paket_layanan.file_petunjuk"
            ><i class="fa fa-download mr-2" />Download Petunjuk</a>
          </p>
          <p v-if="layananSelected.paket_layanan">
            <b>Dokumen Persyaratan</b><br>
            {{ layananSelected.paket_layanan.text_persyaratan }}
          </p>
          <p v-if="layananSelected.paket_layanan">
            <b>Pengambilan Dokumen Kependudukan</b><br>
            {{ layananSelected.paket_layanan.text_ambil_dok }}
          </p>
        </div>

        <h6 class="mt-3">
          <i
            class="fas fa-upload text-primary"
            style="width:1.5rem"
          />Dokumen Persyaratan
        </h6>
        <div class="pl-4">
          <table class="table table-sm">
            <tr
              v-for="(s, i) in layananSelected.layanan_dokumen"
              :key="s.id_layanan_dokumen"
            >
              <td>{{ i+1 }}</td>
              <td>
                {{ s.dokumen.nama_dokumen }} <i
                  class="text-danger"
                  v-if="s.is_harus_diisi"
                >*)</i> <i v-if="s.keterangan">({{ s.keterangan }})</i>
              </td>
              <td
                v-if="s.dokumen.kode_dokumen"
                style="min-width:130px"
              >
                <a
                  :href="$store.getters.getBaseUrl+'/uploads/form/'+s.dokumen.file"
                  target="_blank"
                  class="btn btn-primary btn-sm"
                  :title="'Download Template '+s.dokumen.nama_dokumen"
                ><i class="fa fa-download mr-2" />Form</a>
                <a
                  v-if="s.contoh_form"
                  :href="$store.getters.getBaseUrl+'/api/file/'+s.contoh_form"
                  target="_blank"
                  class="btn btn-success btn-sm"
                  :title="'Download Contoh '+s.dokumen.nama_dokumen"
                ><i class="fa fa-download mr-2" />Contoh</a>
              </td>
              <td v-else />
            </tr>
          </table>
          <p><i><span class="text-danger">*)</span> dokumen wajib</i></p>
        </div>
                
        <h6 class="mt-3">
          <i
            class="fas fa-clock text-primary"
            style="width:1.5rem"
          />Waktu Pengerjaan
        </h6>
        <div class="pl-4">
          <table
            class="table table-sm"
            v-if="layananSelected.paket_layanan"
          >
            <tr v-if="layananSelected.paket_layanan.is_valid_desa">
              <td><b>Validasi Tingkat Desa</b></td>
              <td>{{ (layananSelected.paket_layanan.std_mutu_desa >= 24) ? layananSelected.paket_layanan.std_mutu_desa/24 + ' hari' : layananSelected.paket_layanan.std_mutu_desa + ' jam' }}</td>
            </tr>
            <tr v-if="layananSelected.paket_layanan.is_valid_kecamatan">
              <td><b>Validasi Tingkat Kecamatan</b></td>
              <td>{{ (layananSelected.paket_layanan.std_mutu_kecamatan >= 24) ? layananSelected.paket_layanan.std_mutu_kecamatan/24 + ' hari' : layananSelected.paket_layanan.std_mutu_kecamatan + ' jam' }}</td>
            </tr>
            <tr v-if="layananSelected.paket_layanan.is_valid_dukcapil">
              <td><b>Validasi Tingkat Dukcapil</b></td>
              <td>{{ (layananSelected.paket_layanan.std_mutu_dukcapil >= 24) ? layananSelected.paket_layanan.std_mutu_dukcapil/24 + ' hari' : layananSelected.paket_layanan.std_mutu_dukcapil + ' jam' }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- <h6 class="mt-4"><i class="fa fa-list-ol text-primary" style="width:1.5rem"></i>Mekanisme Permohonan</h6>
            <div class="pl-4">
            </div> -->
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-lihat-layanan')"
        >
          <i class="fa fa-times mr-2" /> Tutup
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import swal from 'sweetalert'
export default {
    data() {
        return {

        }
    },
    computed: {
        dataPermohonan(){
            return this.$store.getters.getDataPermohonan
        },
        selectedPaket(){
            return this.$store.getters.getSelectedPaket
        },
        layananSelected(){
            return this.$store.getters.getLayananSelected
        },
        namaRole(){
            return this.$store.getters.getAuthService.currentRole.nama_role
        }
    },
    methods: {
        setStep(val){
            let step = val
            if(this.dataPermohonan.tahap > 2){
                swal({
                    title: "Perhatian",
                    text: "Yakin ingin mengubah paket/layanan? Permohonan yang sudah dibuat bisa Anda lihat di Riwayat Permohonan",
                    icon: "warning",
                    buttons: {
                        cancel: "Batal",
                        ok: {
                            text: "Ok",
                            value: "ok",
                        },
                    }
                }).then( val => {
                    if(val === 'ok'){
                        this.confirmSetStep(step)
                    }
                })
            } else {
                this.confirmSetStep(step)
            }
        },
        confirmSetStep(val){
            let dataPermohonan = this.dataPermohonan
            dataPermohonan.tahap = val
            this.$store.dispatch('setDataPermohonan', dataPermohonan)
        },
        lihatSyarat(){
            this.$bvModal.show('modal-lihat-layanan')
        },
        ubahJenisForm(){
            // set dia belum memilih online/offline
            let idDataPermohonan = this.dataPermohonan.id_data_permohonan

            let formDataPermohonan = new FormData()
            formDataPermohonan.append('tahap', 3)
            formDataPermohonan.append('is_form_online', 0)
            
            let role = this.$store.getters.getAuthService.currentRole.nama_role
            if(role === 'Operator Desa'){
                formDataPermohonan.append('is_operator_desa', 1)
            }
            this.$store.dispatch('updatePermohonanPenduduk', {id: idDataPermohonan, form: formDataPermohonan}).then(res => {
                if(res.data.status){
                    let dispatch = 'showDataPermohonanPenduduk'
                    if(this.namaRole == 'Penduduk'){
                        dispatch = 'showDataPermohonanPenduduk'
                    } else if(this.namaRole == 'Operator Desa' || this.namaRole == 'Kepala Desa'){
                        dispatch = 'showDataPermohonanPendudukByDesa'
                    } else if(this.namaRole == 'Operator Kecamatan'){
                        dispatch = 'showDataPermohonanPendudukByKecamatan'
                    } else if(this.namaRole == 'Operator Dukcapil' || this.namaRole == 'Operator Dukcapil Kecamatan'){
                        dispatch = 'showDataPermohonanPendudukByDukcapil'
                    }
                    
                    this.$store.dispatch(dispatch, idDataPermohonan)
                } else {
                    swal({
                        title: "Gagal",
                        text: res.data.message,
                        icon: "error",
                        buttons: "Ok"
                    })
                }
            })
        }
    }
}
</script>